module.exports = __webpack_public_path__ + "img/svekketis.f7fbadfe.jpg";